import { createElement, useState, useEffect } from "@wordpress/element";

import { BiWorld } from "react-icons/bi";
import { BsLightningCharge } from "react-icons/bs";
import MenuIcon from "./MenuIcon";

import { RiArrowDownSLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";

export default function MobileMenu({ index_menu, lang_menu, fast_menu, lang }) {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isLangOpen, setIsLangOpen] = useState(false);
	const [isFastOpen, setIsFastOpen] = useState(false);

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	const toggleLang = () => {
		setIsLangOpen(!isLangOpen);
	};
	const toggleFast = () => {
		setIsFastOpen(!isFastOpen);
	};
	useEffect(() => {
		if (isMenuOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}

		return () => {
			document.body.style.overflow = "auto";
		};
	}, [isMenuOpen]);

	return (
		<>
			{/* Hamburger Button */}
			<button
				onClick={toggleMenu}
				className="fixed top-10 ltr:right-4 rtl:left-4 z-40  bg-shirinmehr-dark1 text-white rounded-md "
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="40"
					height="40"
					viewBox="0 0 50 50"
				>
					<path
						fill="currentColor"
						d="M10 12h30v4H10zm0 10h30v4H10zm0 10h30v4H10z"
					/>
				</svg>
			</button>

			{/* Fullscreen Menu */}
			<div
				className={`fixed z-40 top-0 ltr:right-0 rtl:left-0 w-full h-full  bg-white ransform ${
					isMenuOpen ? "translate-x-0" : "translate-x-full"
				} transition-transform duration-300 z-40 h-screen overflow-y-scroll pb-24    `}
			>
				{/* lang  Data */}

				<div
					className={`ransform z-50  transition-transform  fixed  h-screen w-full  -top-0  bg-shirinmehr-dark2/90  flex items-center justify-center p-12  text-white
					${isLangOpen ? " -translate-y-0 " : "translate-x-full"}

					
					`}
				>
					<div className=" flex flex-col  rtl:items-end items-start gap-2 ">
						<div
							onClick={toggleLang}
							className="  w-8 h-8 rounded-md rtl:rotate-180 bg-white text-shirinmehr-dark2  flex items-center justify-center "
						>
							{">"}
						</div>

						{lang_menu.menus.map((item, index) => {
							return (
								item.code !== lang && (
									<a href={item.link_data.link}>
										<div className="  bg-shirinmehr-light1  text-black  px-4 py-2 rounded-md min-w-44 flex flex-col gap-2 items-center justify-center">
											{item.subTitle}
										</div>
									</a>
								)
							);
						})}
					</div>
				</div>
				{/* Fast Data */}

				<div
					className={`ransform z-50  transition-transform  fixed  h-screen w-full  -top-0  bg-shirinmehr-dark2/90  flex items-center justify-center p-12  text-white
					${isFastOpen ? " -translate-y-0 " : "translate-x-full"}

					
					`}
				>
					<div className=" flex flex-col  items-end gap-2 ">
						<div
							onClick={toggleFast}
							className="  w-8 h-8 rounded-md rtl:rotate-180  bg-white text-shirinmehr-dark2  flex items-center justify-center "
						>
							{">"}
						</div>
						<div className="   text-black  gap-4 rounded-md min-w-44 flex flex-col  items-center justify-center">
							{fast_menu.menus &&
								fast_menu.menus.map((item, index) => {
									return (
										<a
											href={item.link_data.link}
											target={item.link_data.new_window ? "_blank" : undefined}
											className=" w-full"
										>
											<div
												key={index}
												className="bg-shirinmehr-light1 w-full flex  justify-center items-center py-2 rounded-lg"
											>
												{item.title}
											</div>
										</a>
									);
								})}
						</div>
					</div>
				</div>

				{/* Close Button */}

				<div className=" py-6 w-full border-b-[1px] border-gray-300 px-2  ">
					<div className="flex gap-4 px-2  justify-between items-center ">
						<div className=" flex items-center justify-center gap-2">
							<div className=" flex items-center w-fit ">
								{lang_menu.menus &&
									lang_menu.menus.map((item, index) => {
										return (
											item.code === lang && (
												<div
													onClick={toggleLang}
													className=" border-[1px] w-full flex items-center  gap-2 bg-shirinmehr-dark1 text-white py-3 rounded-md px-4 "
												>
													<BiWorld />
													<div className=" text-xs ">{item.title}</div>
												</div>
											)
										);
									})}
							</div>
							{/* Fast Mneu  btn */}
							<div
								onClick={toggleFast}
								className=" bg-shirinmehr-dark1 gap-2  text-white min-h-10 rounded-md px-4 text-sm flex items-center "
							>
								<div>
									<BsLightningCharge />
								</div>
								<div>{fast_menu && fast_menu.data.title}</div>
							</div>{" "}
						</div>

						<button
							onClick={toggleMenu}
							className=" ltr:right-4 w-10 h-10 flex items-center justify-center rtl:left-4 bg-shirinmehr-dark1 text-white p-2 rounded-md"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
							>
								<path
									fill="currentColor"
									d="M18.3 5.71l-1.42-1.42L12 9.17 7.11 4.29 5.7 5.71 10.59 10.6 5.7 15.49l1.41 1.41L12 11.83l4.89 4.89 1.41-1.41-4.89-4.89 4.89-4.89z"
								/>
							</svg>
						</button>
					</div>
				</div>

				{/* Menu Items */}
				<div className="mt-8   ">
					<ul className="space-y-4 text-lg ">
						{index_menu &&
							index_menu.menus.map((item, index) => (
								<li key={index} className=" px-4">
									{item.link ? (
										<a
											href={item.link_data.link}
											target={item.link_data.new_window ? "_blank" : undefined}
											className=" px-6"
										>
											{item.title}
										</a>
									) : (
										<div>
											<div className=" flex gap-1 items-center font-extrabold text-xl ">
												<div>{item.title}</div>
											</div>
											<div>
												<Menu data={item.sub} />
											</div>
										</div>
									)}
								</li>
							))}
					</ul>
				</div>
			</div>
		</>
	);
}

const MenuItem = ({ item }) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleClick = () => {
		if (item.sub) {
			setIsOpen(!isOpen);
		}
	};

	return (
		<li>
			<div className=" " onClick={handleClick} style={{ cursor: "pointer" }}>
				<div
					className={`${
						item.sub ? " bg-gray-200 group px-0 " : "bg-gray-100 px-6  "
					}  flex items-center py-1 px-4  my-2`}
				>
					{item.sub && (
						<div>
							{isOpen ? (
								<RiArrowDownSLine className="transition  group-hover:rotate-180 " />
							) : (
								<RiArrowDropUpLine className="transition  group-hover:rotate-180 " />
							)}
						</div>
					)}
					<div className="  ">
						<a href={item.link_data.link}>
							<div>{item.title}</div>
							{item.subTitle && <div className=" text-sm">{item.subTitle}</div>}
						</a>
					</div>
				</div>
			</div>
			{isOpen && item.sub && (
				<ul>
					{item.sub.map((subItem, index) => (
						<MenuItem key={index} item={subItem} />
					))}
				</ul>
			)}
		</li>
	);
};

const Menu = ({ data }) => {
	return (
		<ul>
			{data.map((item, index) => (
				<MenuItem key={index} item={item} />
			))}
		</ul>
	);
};
